import React from 'react';
import _ from 'lodash';
import axios from 'axios';
import R from 'ramda';
import moment from 'moment';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Dropdown,
  Menu,
  Label,
  Popup,
} from 'semantic-ui-react';
import { Link } from 'react-router';
import { compose } from 'recompose';

import HashtagScannerModal from '../../components/hashtag-scanner-modal';
import AddCampaignModal from '../../components/add-campaign-modal';
import ChaseEmailSendModal from '../../components/chase-email-send-modal';

import { loadingCampaign } from './actions';
import { loadCampaignAnalytics } from '../campaign-analytics/actions';

import { clearStatusBar } from '../../containers/status-bar/actions';
import { authService } from '../../utils/auth-service';

import hasRESTClient from '../../hocs/has-rest-client';
import hasOrgansation from '../../hocs/has-organisation';

import { isTeam, KASPERSKY, TD } from './../../utils/private-data-whitelist';
import { transformHashtagstIntoArray } from '../../utils/hashtags-utils';
import {
  PARTNER_AGENCY,
  CLIENT,
  ANALYTICS,
  FACEBOOK,
  TWITTER,
  INSTAGRAM,
} from '../../utils/static-configuration';
import { checkUserIsTeamMember, checkUserHasAdminRights } from '../../utils/role-service';
import { updateCampaign } from '../../utils/jsonapi-functions/campaigns';
import { reportError } from '../../utils/error-handling-service';
import { setModal } from '../../actions/modal';
import ThemeSelector from '../../themes/theme-selector';


const blackColorLink = { color: 'black' };

const DEBOUNCE_TIMEOUT = 800;

const currentTheme = ThemeSelector.theme();

const RESTRICTED_CORQ_DOMAINS = [
  'data.corq.studio',
  'corq.dyzio.co',
];

const INITIAL_HASHTAG_SCANNER_STATE = {
  hashtagScannerModalOpen: false,
  isScanning: false,
  validHashtags: true,
  hashtagsErrors: [],
  currentScannedPlatform: null,
  scannerResultsCount: null,
  hashtags: [],
};

class Campaign extends React.Component {
  static contextTypes = {
    router: PropTypes.object.isRequired,
  };

  static propTypes = {
    params: PropTypes.object.isRequired,
  }

  constructor(props, context) {
    super(props, context);

    this.state = {
      campaignName: null,
      hashtags: null,
      campaignId: null,
      budgetAllocated: 'Waiting...',
      filterDiscussionListByTerm: null,
      editCampaignModalOpen: false,
      campaignUpdatedFields: {},
      chaseModalOpen: false,
      ...INITIAL_HASHTAG_SCANNER_STATE,
    };

    this.updateCampaign = this.updateCampaign.bind(this);

    this.hashtagScannerAPI = axios.create({
      baseURL: 'https://b7o8doqzfb.execute-api.eu-west-1.amazonaws.com/production/hashtags',
      timeout: 20000,
      headers: {
        Authorization: `Bearer ${authService.getToken()}`,
      },
    });
    this.automationrAPI = axios.create({
      baseURL: process.env.REACT_APP_AUTOMATION_API,
      timeout: 20000,
      headers: {
        Authorization: `Bearer ${authService.getToken()}`,
      },
    });
  }

  componentDidMount() {
    const { userInfo: { organisationId }, restClient } = this.props;

    const myUserRole = this.props.myUserRole;
    if (myUserRole === CLIENT || myUserRole === PARTNER_AGENCY) {
      this.context.router.push('/dashboard');
    }
    const campaignId = this.props.params ? this.props.params.id : '';
    const fastLoad = this.props.location.query.fast
      ? this.props.location.query.fast === 'true' : false;

    console.log(this.props);
    this.setState({ campaignId, isLoadingTotals: true });

    restClient.get(`/campaigns/${campaignId}`).then(response => {
      const { data: { data: { attributes: { name: campaignName, hashtags, campaignType } } } } = response;
      this.setState({
        campaignName,
        hashtags,
        campaignType,
      });
    });

    this.props.onLoadingCampaign(campaignId, null, fastLoad);
  }

  async updateCampaign(budget) {
    const id = this.props.campaign.get('id');
    const oldBudget = this.props.campaign.get('budget');

    try {
      updateCampaign(id, budget);
    } catch (error) {
      reportError('UPDATE_CAMPAIGN_ERROR', error.message);
      this.props.onSetStatusBar(error.message, 'red');
    }
  }

  setModal = modalName => this.props.onSetModal(modalName);

  feedback = action => this.context.router.push(action)

  openReport = type => {
    const { campaignId } = this.state;
    window.open(`${currentTheme.shareSite}/report/${campaignId}/${type}`);
  }

  handleHashtagInputsChange = (e, { name, value }) => {
    const { hashtags: stateHashtags } = this.state;
    const hashtags = _.clone(stateHashtags);
    const existing = _.find(hashtags, ['name', name]);
    if (existing) {
      existing.value = value;
    } else {
      hashtags.push({
        name,
        value,
      });
    }

    this.setState({
      hashtags,
    });
  }

  handleHashtagScannerState = () => {
    const { hashtagScannerModalOpen } = this.state;
    this.setState({
      hashtagScannerModalOpen: !hashtagScannerModalOpen,
    });
  }

  scan = function* scan() {
    const { campaign } = this.props;
    const { hashtags } = this.state;
    const campaignId = campaign.get('id');
    const query = platform => this.hashtagScannerAPI.post('/scan', {
      data: {
        campaignId,
        platform: _.lowerCase(platform),
        hashtags: _.map(hashtags, hashtag => _.trim(hashtag.value)),
      },
    });
    // yield query(YOUTUBE);
    yield query(INSTAGRAM);
    yield query(TWITTER);
    yield query(FACEBOOK);
  }

  getHashtagsErrors = () => {
    const REGEX = /^(#|@?)\S{3,}$/g; // allow wide chars in hashtags
    const { hashtags } = this.state;
    const values = _.map(hashtags, (hashtag => _.trim(hashtag.value)));
    const matches = _.map(values, (value => value.match(REGEX)));
    const errors = _.map(matches, (value, index) => ({ isError: _.isNull(value), position: index }));
    return errors;
  }

  scanHashtags = () => {
    const { campaign } = this.props;
    const TIMEOUT = 2200;
    const generator = this.scan();
    const channels = [INSTAGRAM, TWITTER, FACEBOOK];
    _.forEach(channels, async (channel, index) => {
      const isFacebook = channel === FACEBOOK;
      setTimeout(async () => {
        const { data: { data } } = await generator.next().value;
        const state = {
          currentScannedPlatform: channel,
          scannerResultsCount: _.sumBy(data, item => item.trackedAssets.length || 0),
        };
        this.setState({
          ...state,
        }, () => {
          if (isFacebook) {
            _.delay(() => this.setState({
              ...INITIAL_HASHTAG_SCANNER_STATE,
            }, () => this.props.onLoadingCampaign(campaign.get('id'))), TIMEOUT);
          }
        });
      }, TIMEOUT * R.inc(index));
    });
  }

  toggleEditCampaignModalState = () => {
    this.setState(prevState => ({
      editCampaignModalOpen: !prevState.editCampaignModalOpen,
    }));
  }

  handleScanButtonClick = () => {
    const hashtagsErrors = this.getHashtagsErrors();
    const hasError = _.find(hashtagsErrors, ['isError', true]);
    if (!hasError) {
      this.setState({
        isScanning: true,
        hashtagsErrors: [],
      }, this.scanHashtags);
    } else {
      this.setState({
        hashtagsErrors,
      });
    }
  }

  onHashtagScannerModalClose = () => {
    this.setState({
      ...INITIAL_HASHTAG_SCANNER_STATE,
    });
  }

  onFilterDiscussionListByTermChanged = _.debounce((event, data) => {
    const { value } = data;
    this.setState({
      filterDiscussionListByTerm: value,
    });
  }, DEBOUNCE_TIMEOUT);

  onEditCampaignTextField = (event, { name, value }) => {
    const { campaignUpdatedFields } = this.state;
    _.set(campaignUpdatedFields, name, value);
    this.setState({
      campaignUpdatedFields,
    });
  }

  onLiveDateChange = date => {
    const value = date.format();
    this.onEditCampaignTextField(null, { name: 'liveDate', value });
  }

  onEndDateChange = date => {
    const value = date.format();
    this.onEditCampaignTextField(null, { name: 'endDate', value });
  }

  onCampaignCurrencyChanged = (event, { value }) => {
    this.onEditCampaignTextField(null, { name: 'currency', value });
  }

  onSubmitEditCampaignForm = () => {
    const { campaignUpdatedFields } = this.state;
    const { name, budget, id, currency, endDate, liveDate, hashtags } = campaignUpdatedFields;
    const { restClient } = this.props;
    const attributes = {
      name,
      budget,
      currency,
      liveDate,
      endDate,
      hashtags,
    };
    restClient.patch(`campaigns/${id}`, {
      data: {
        attributes: _.pickBy(attributes),
      },
    }).then(() => {
      this.setState({
        editCampaignModalOpen: false,
      }, () => this.props.onLoadingCampaign(id));
    });
  }

  onSettingsDropdownItemClick = value => {
    if (value === 'campaign-settings') {
      const { campaign } = this.props;
      const campaignJSON = campaign.toJSON();
      const { name, budget, currency, liveDate, endDate, hashtags } = campaignJSON;
      this.setState({
        editCampaignModalOpen: true,
        campaignUpdatedFields: {
          name, budget, currency, liveDate, endDate, hashtags, id: campaign.get('id'),
        },
      });
    } else {
      this.context.router.push(value);
    }
  }

  toggleChaseEmailModal = () => this.setState(prevState => ({
    chaseModalOpen: !prevState.chaseModalOpen,
  }))

  handleACRScan = () => {
    const { campaignId } = this.state;
    this.setState({
      automationScanLoading: true,
    });
    this.automationrAPI.post(`/run-acr-scan/${campaignId}`)
      .then(() => this.setState({
        automationScanLoading: false,
      }))
      .then(() => this.setState({ campaignId, activeTab: ANALYTICS }))
      .catch(e => reportError('ACR_ERROR', e));
  }

  handleAutomatedCampaignScan = () => {
    const { campaignId } = this.state;
    this.setState({
      automationScanLoading: true,
    });
    this.automationrAPI.post(`/run-automated-scan/${campaignId}`)
      .then(() => this.setState({
        automationScanLoading: false,
      }))
      .then(() => this.setState({ campaignId, activeTab: ANALYTICS }))
      .catch(e => reportError('AUTO_CAMPAIGN_ERROR', e));
  }

  render() {
    const {
      myUserRole,
      campaign,
      campaignLoading,
      campaignLoadError,
      members,
      showModal,
      userInfo,
    } = this.props;

    const { organisationId, isUserSuperAdmin } = userInfo;
    const { host } = window.location;

    const isCorq = _.includes(RESTRICTED_CORQ_DOMAINS, host);
    const isDyzioTeam = isTeam(organisationId, TD);
    const isKaspersky = isTeam(organisationId, KASPERSKY);
    const shouldRenderAuditTrail = isDyzioTeam || (isKaspersky && isUserSuperAdmin);

    const {
      campaignId,
      hashtagScannerModalOpen,
      isScanning,
      currentScannedPlatform,
      scannerResultsCount,
      hashtagsErrors,
      campaignUpdatedFields,
      editCampaignModalOpen,
      campaignType,
      chaseModalOpen,
    } = this.state;

    if (!campaignId) return null;

    const currency = campaignUpdatedFields && campaignUpdatedFields.currency;
    const liveDate = campaignUpdatedFields && moment(campaignUpdatedFields.liveDate);
    const endDate = campaignUpdatedFields && moment(campaignUpdatedFields.endDate);
    const campaignJSON = campaign.toJSON();

    const name = _.get(campaignJSON, 'name', this.state.campaignName);
    const hashtags = _.get(campaignJSON, 'hashtags', this.state.hashtags);

    const campaignFormProps = {
      name: campaignUpdatedFields.name,
      budget: campaignUpdatedFields.budget,
      currency,
      liveDate,
      endDate,
      campaignType,
      hashtags: campaignUpdatedFields.hashtags,
      onInputChange: this.onEditCampaignTextField,
      onLiveDateChange: this.onLiveDateChange,
      onEndDateChange: this.onEndDateChange,
      onCurrencyChange: this.onCampaignCurrencyChanged,
    };

    const creatorMembers = [];

    const isManual = campaignType === 'WORKFLOW';
    const isACR = campaignType === 'ACR';
    const isAutomatedCampaign = campaignType === 'AUTOMATED';
    const isAuto = (isACR || isAutomatedCampaign);
    const hasInfluencers = creatorMembers.length > 0 || campaign && (campaignJSON.pendingInvitations || []).length > 0;
    const isUserTeamMember = isUserSuperAdmin || checkUserIsTeamMember(myUserRole);
    const isUserAnAdmin = isUserSuperAdmin || checkUserHasAdminRights(myUserRole);

    const hashtagsArray = transformHashtagstIntoArray(hashtags);

    const menuOptions = [];

    if (!isCorq) {
      menuOptions.push({
        key: 'invite',
        text: 'Invite people to this campaign',
        onClick: () => this.onSettingsDropdownItemClick(`/campaign/${campaignId}/invite`),
      });

      if (isUserAnAdmin) {
        menuOptions.push({
          key: 'manage',
          text: 'Manage people on this campaign',
          onClick: () => this.onSettingsDropdownItemClick(`/campaign/${campaignId}/manage`),
        });
      }
    }

    menuOptions.push({
      key: 'chase email',
      text: 'Send chase email',
      onClick: this.toggleChaseEmailModal,
    });

    menuOptions.push({
      key: 'scan-now',
      text: 'Scan for posts now...',
      value: 'scan-now',
      onClick: () => this.handleAutomatedCampaignScan(),
    });

    const isCollaborationRoute = _.has(this.props.params, 'collabId');

    const SHOW_SETUP_TAB = false;
    return (
      <div className="page">
        <div className={isCollaborationRoute ? 'white-header collab' : 'white-header'}>
          <div className="row large">
            <div className="flex-spacer">
              <h1>
                {name}{' '}
                {
                  isAutomatedCampaign && _.map(hashtagsArray, ht => (
                    <Label basic color="grey">{ht}</Label>
                  ))
                }


              </h1>
            </div>
            <div className="flex-item">
              { isUserTeamMember &&
              <Menu>
                <Dropdown
                  text="Quick Links &nbsp;"
                  icon="settings"
                  options={menuOptions}
                  pointing="right top"
                  item
                />
              </Menu>
              }
            </div>
          </div>
          { isUserTeamMember && !isCollaborationRoute ?
            <div className="row no-bottom-padding">
              <div className="large-tabs">

                {
                  !isACR && SHOW_SETUP_TAB &&
                  <Link
                    as="div" to={`/campaign/${campaignId}/setup`}
                    className="flex-item"
                    activeClassName="active"
                    style={blackColorLink}
                  >
                    <h4>
                      <nobr>
                        Setup
                      </nobr>
                    </h4>
                  </Link>
                }

                {
                  isACR &&
                  <Link
                    as="div" to={`/campaign/${campaignId}/acr-setup`}
                    className="flex-item"
                    activeClassName="active"
                    style={blackColorLink}
                  >
                    <Popup
                      trigger={
                        <h4>
                          <nobr>
                            Setup
                          </nobr>
                        </h4>
                      }
                      content="Set up your automated channel report"
                    />
                  </Link>
                }

                {
                  !isACR &&
                  <Link
                    as="div" to={`/campaign/${campaignId}/collaborations`}
                    className="flex-item"
                    activeClassName="active"
                    style={blackColorLink}
                  >
                    <Popup
                      trigger={<h4><nobr>Influencers</nobr></h4>}
                      content="Manage your campaign influencers. Add, invite and request Authorization."
                    />
                  </Link>
                }

                {
                  isAuto &&
                  <Link
                    as="div" to={`/campaign/${campaignId}/notifications`}
                    className="flex-item"
                    activeClassName="active"
                    style={blackColorLink}
                  >
                    <h4>
                      <nobr>
                        Notifications
                      </nobr>
                    </h4>
                  </Link>
                }


                <Link
                  as="div" to={`/campaign/${campaignId}/analytics`}
                  className="flex-item"
                  activeClassName="active"
                  style={blackColorLink}
                >
                  <h4><nobr>Dashboard</nobr></h4>
                </Link>

                <Link
                  as="div" to={`/campaign/${campaignId}/reports`}
                  className="flex-item"
                  activeClassName="active"
                  style={blackColorLink}
                >
                  <h4><nobr>Reports</nobr></h4>
                </Link>

                {/* {
                  !isACR &&
                  <Link
                    as="div" to={`/campaign/${campaignId}/payments`}
                    className="flex-item"
                    activeClassName="active"
                    style={blackColorLink}
                  >
                    <Popup
                      trigger={<nobr>Influencer fees</nobr>}
                      content="Keep track of your campaign budget and individual influencer fees"
                    />
                  </Link>
                } */}
                {
                  shouldRenderAuditTrail && isManual &&
                  <Link
                    as="div" to={`/campaign/${campaignId}/audit-trail`}
                    className="flex-item"
                    activeClassName="active"
                    style={blackColorLink}
                  >
                    <Popup
                      trigger={<nobr>Audit trail</nobr>}
                      content="Audit trail description"
                    />
                  </Link>
                }

                <Link
                  as="div" to={`/campaign/${campaignId}/settings`}
                  className="flex-item"
                  activeClassName="active"
                  style={blackColorLink}
                >
                  Settings
                </Link>


              </div>
            </div>
            :
            <div className="spacer large" />
          }
        </div>
        <div className="page-content">
          {
            campaignLoading &&
            <div className="discussion-preloader">
              <img src="/icons/dyzio-icon.svg" alt="Loading..." />
            </div>
          }
          { !campaignLoading && !campaignLoadError && this.props.children && React.cloneElement(this.props.children, this.props) }

        </div>
        {
          hashtagScannerModalOpen &&
          <HashtagScannerModal
            isEmptyState={!hasInfluencers}
            isScanning={isScanning}
            currentScannedPlatform={currentScannedPlatform}
            onClose={this.handleHashtagScannerState}
            onInputValueChange={this.handleHashtagInputsChange}
            onScanHandler={this.handleScanButtonClick}
            scannerResultsCount={scannerResultsCount}
            hashtags={hashtags}
            hashtagsErrors={hashtagsErrors}
          />
        }
        {
          editCampaignModalOpen && campaign &&
          <AddCampaignModal
            title="Edit campaign details"
            buttonLabel="Save"
            addCampaignFormProps={campaignFormProps}
            onClose={this.toggleEditCampaignModalState}
            onAddCampaignSubmit={this.onSubmitEditCampaignForm}
          />
        }
        {
          chaseModalOpen && <ChaseEmailSendModal campaignId={campaignId} onClose={this.toggleChaseEmailModal} />
        }
      </div>
    );
  }
}

const mapStateToProps = state => ({
  campaign: state.campaign.get('campaign'),
  myUserRole: state.campaign.get('myUserRole'),
  members: state.members.get('members'),
  showModal: state.modal.get('showModal'),
  campaignLoadError: state.campaign.get('campaignLoadError'),
  campaignLoading: state.campaign.get('campaignLoading'),
});

export function mapDispatchToProps(dispatch) {
  return {
    dispatch,
    onClearStatusBar: () => dispatch(clearStatusBar()),
    onLoadingCampaign: (campaignId, silent, fastLoad) => dispatch(loadingCampaign(campaignId, silent, fastLoad)),
    onLoadCampaignAnalytics: data => dispatch(loadCampaignAnalytics(data)),
    onSetModal: modalName => dispatch(setModal(modalName)),
  };
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  hasOrgansation,
  hasRESTClient,
)(Campaign);



/** WEBPACK FOOTER **
 ** ./src/containers/campaign/index.js
 **/